export default __webpack_public_path__ + "static/media/codeInLogo.be1b6b9b.png";